export default {
  getCurrentCompanyId,
};

function getCurrentCompanyId(user, isMobile) {
  let currentCompanyId = localStorage && localStorage.current_company_id ? parseInt(localStorage.current_company_id, 10) : null;
  if (!currentCompanyId) {
    // pull from user settings (if available)...
    if (user.settings && user.settings.current_company_id) {
      currentCompanyId = user.settings.current_company_id;
    }
  }
  
  let userHasCompany = true;
  
  if (currentCompanyId && user.role.name != 'super_user') {
    userHasCompany = user.companies.find(c => {
      return c.id == currentCompanyId;
    });
    if (!userHasCompany) {
      userHasCompany = user.vendor_companies.find(c => {
        return c.id == currentCompanyId;
      });
    }
  }

  // getting first company if current_company doesn't exist
  if (!currentCompanyId || !userHasCompany) {
    if (user.companies && user.companies.length) {
      currentCompanyId = user.companies[0].id;
    }
  }
  return currentCompanyId;
}



// WEBPACK FOOTER //
// ./src/helpers/user/UserUtil.js